<template>
    <div class="layout-auth">
        <header-auth
            title=""
            href="/auth/login"
            buttonText="Обычная авторизация"
        />
        <div class="layout-auth__section">
            <div class="layout-auth__section-container">
                <div class="layout-auth__section-head">
                    <div class="layout-auth__section-head-title">Войти в систему</div>
                </div>
                <div>
                    <form-auth-check-phone v-if="!isPhoneChecked" @submitForm="submitForm"/>
                    <form-login-sms
                        v-if="isPhoneChecked"
                        @submitFormLogin="submitFormLogin"
                        @codeRepeat="codeRepeat"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormAuthCheckPhone from '../../components/Forms/FormAuthCheckPhone';
import FormLoginSms from '../../components/Forms/FormLoginSms';
import HeaderAuth from '../../components/Headers/HeaderAuth';
import serviceAuth from '../../services/serviceAuth';
/**
 * @see LayoutAuth.vue - стили родителя
 */
export default {
    name: 'ViewAuthCheckPhone',
    components: {
        FormAuthCheckPhone,
        HeaderAuth,
        FormLoginSms
    },
    /**
     * Входные данные компонента
     * @property {boolean} isPhoneChecked - условие проверки телефона и отправки смс
     * @property {string} phone - телефон
     */
    data: () => ({
        isPhoneChecked: false,
        phone: '',
        login: '',
        password: ''
    }),
    methods: {
        /**
         * событие отправки формы
         * @param {object} data - данные формы
         */
        submitForm(data) {
          this.submitFormLogin(data)
            // this.checkPhone(data);
        },
        /**
         * событие отправки формы на логин по телефону
         * @param {object} data - данные формы
         */
        // async submitFormLogin(data) {
        //     data.phone = this.phone;
        //     let {succes = false, error = false, message = ''} = await serviceAuth.loginSms(data);
        //     // console.log(error);
        //     if (succes) {
        //         this.$router.push({name: 'analyticsSummary'});
        //     } else if (error) {
        //         alert("Пароль введен неверно");
        //     }
        //     if(message){
        //         alert(message);
        //     }
        // },
        /**
         * событие отправки формы на логин по телефону
         * @param {object} data - данные формы
         */
        async submitFormLogin(data) {
            // data.login = this.login;
            // data.password = this.password;
            let {succes = false, error = false, message = ''} = await serviceAuth.login(data);//loginSms
            // console.log(error);
            if (succes) {
                this.$router.push({name: 'analyticsSummary'});
            } else if (error) {
                alert("Пароль введен неверно");
            }
            if(message){
                alert(message);
            }
        },
        /**
         * событие повторного получения пароля
         */
        codeRepeat() {
            let repeatData = {
                // phone: this.phone
                login: this.login,
                password: this.password
            }
            this.checkPhone(repeatData);
        },
        /**
         * проверка телефона
         * @async
         * @param {object} data - данные для отправки по апи
         */
        // async checkPhone(data)
        // {
        //     let {phone = false, message = 'Неверно введен телефон'} = await serviceAuth.checkPhone(data);
        //     if (phone) {
        //         this.isPhoneChecked = true;
        //         this.phone = phone;
        //         alert("Код отправлен");
        //     }else {
        //         this.isPhoneChecked = false;
        //         alert(message);
        //     }
        // },
        /**
         * проверка телефона
         * @async
         * @param {object} data - данные для отправки по апи
         */
        async checkPhone(data) {
            let {login = '', password = ''} = data;
            this.login = login;
            this.password = password;
            let {succes = false, message = false, error = false} = await serviceAuth.checkPhone(data);
            if (succes !== false) {
                this.isPhoneChecked = true;
                // alert(succes);
            }
            else if (message !== false) {
                this.isPhoneChecked = false;
                alert(message);
            }
            else if (error !== false) {
                this.isPhoneChecked = false;
                alert('Извините, сервер временно недоступен');
            }
        }
    }
}
</script>